// @ts-nocheck
class WIvideoPaly extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        // Run once the DOM is ready. If it's already parsed (deferred/late upgrade),
        // set up the observer immediately instead of waiting for a DOMContentLoaded
        // that may never fire again.
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.videoInterSection(), { once: true });
        } else {
            this.videoInterSection();
        }
    }
    // Video play
    videoPlay() {
        let video = this.querySelector('video');
        let videoSource = this.querySelector('.WI_videoSource');
        if (!video) return;

        // Mobile (iOS/Android) autoplay requires the muted + inline PROPERTIES to be
        // set, not just the HTML attributes, before play() is called.
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        // If the <source> already has a src (set server-side), iOS handles autoplay
        // natively — don't reload it (that would restart the video). Only lazy-load
        // from data-videourl when no src is present yet.
        if (videoSource && !videoSource.getAttribute('src')) {
            let videoUrl = video.getAttribute('data-videourl');
            if (videoUrl) {
                videoSource.src = videoUrl;
                video.load();
            }
        }
        this.attemptPlay(video);
    }
    // play() can reject on mobile if called before the media is ready — retry on canplay
    attemptPlay(video) {
        let promise = video.play();
        if (promise && typeof promise.catch === 'function') {
            promise.catch(() => {
                video.addEventListener('canplay', () => {
                    video.play().catch(() => {});
                }, { once: true });
            });
        }
    }
    // Video intersection
    videoInterSection() {
        // Observe the <video> (which has real dimensions) rather than the
        // zero-height <wi-videoplay> wrapper — a zero-area target can fail to
        // trigger IntersectionObserver on iOS Safari.
        let target = this.querySelector('video') || this;
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.videoPlay();
                    observer.unobserve(entry.target);
                }
            });
        },{
            rootMargin: "200px", // Load a bit earlier
        });
        observer.observe(target);
    }
}

customElements.define('wi-videoplay', WIvideoPaly);
